import _ from 'lodash';

export function dataProcess(inputData) {
    var originalSection = inputData['section'];
    var allLec = _.filter(originalSection, function(i) {return i['name'].length === 1});
    var resultAry = allLec.map(singleLec => {
        var currLec = singleLec['name']
        var resultObj = {};
        var LecObj = {};
        LecObj[currLec] = singleLec['time'];
        resultObj["Lec"] = LecObj;
        var resultLst = [];
        var currSec = _.filter(originalSection, function(i) {
            return i['name'].substring(0, 1) === currLec && i['name'].length > 1
        });
        resultLst = currSec.map(singleSec => {
            var secObj = {};
            secObj[singleSec['name']] = singleSec['time'];
            return secObj
        })
        resultObj["Sec"] = resultLst;
        return resultObj
    })
    var returnObj = {...inputData};
    returnObj['timeInfo'] = resultAry;
    returnObj['section'] = null;
    return returnObj
}